import {
	CHAT_COMMAND__GET_CONVERSATIONS,
	CHAT_COMMAND__GET_RECIPIENTS_ONLINE_STATUSES,
	CHAT_MSG_TYPE__CHAT_MSG,
	CHAT_MSG_TYPE__ERROR,
	CHAT_MSG_TYPE__IS_TYPING,
	CHAT_MSG_TYPE__RECIPIENT_STATUS_CHANGE,
	CHAT_MSG_TYPE__OFFLINE_WAIT,
	CHAT_MSG_TYPE__COMMAND,
	CHAT_MSG_TYPE__COMMAND_RESPONSE,
	CHAT_MSG_TYPE__OPEN_CONVERSATION,
	CHAT_MSG_TYPE__CLOSE_CONVERSATION,
	CHAT_MSG_TYPE__PING,
	CHAT_MSG_TYPE__PONG,
	CHAT_MSG_TYPE__APP_STATE_CHANGE,
	SOCKET_STATUS__OPEN,
	SOCKET_STATUS__CLOSED,
	SOCKET_STATUS__CONNECTING,
	SOCKET_STATUS__RETRYING,
	SOCKET_STATUS__FAILED,
	SOCKET_STATUS__CLOSING,
	SOCKET_STATUS__REFUSED,
	CHAT_STATUS_ONLINE,
	CHAT_STATUS_OFFLINE,
} from '../../constants/Chat.js';
import {
	APP_STATE_ACTIVE,
	APP_STATE_INACTIVE,
	APP_STATE_BACKGROUND,
} from '@onehat/ui/src/Constants/AppStates.js';
import AppGlobals from '../../AppGlobals.js';
import oneHatData from '@onehat/data';
import getTokenHeaders from '@onehat/ui/src/Functions/getTokenHeaders.js';
import EventEmitter from '@onehat/events';
import _ from 'lodash';

const pingTimeout = 37003; // ms (prime number)

let userIsTypingTimeout = null,
	currentRecipientIsTypingTimeout = null,
	socket;

// NOTE: This Chat module assumes each conversation is between only two people:
// a sender and a recipient. Each conversation is indexed by a conversation_num.

export default class ChatManager extends EventEmitter {

	constructor(reduxGetState) {
		super(...arguments);

		this.reduxGetState = reduxGetState;
		this.chatToken = null;
		this.socket = null;
		this.retryAttempt = null;
		this.socketStatus = SOCKET_STATUS__CLOSED;
		this.receipientsOnlineStatuses = {}; // format: { conversation_num: STATUS }
		this.currentRecipientIsTyping = false;
		this.conversations = {}; // format: { conversation_num: { recipient_id, converation_num, full_name, }, }
		this.currentConversation = null; // format: { recipient_id, converation_num, full_name, }
		this.badgeCounts = {}; // format: { conversation_num: count, }
		this.badgeCountTotal = 0;
		this.isTyping = false;
		this.ChatMessages = oneHatData.getRepository('ChatMessages');

		this.registerEvents([
			'setChatIsSocketConnected',
			'setChatSocketStatus',
			'setChatCurrentConversation',
			'setChatRecipientIsTyping',
			'setChatBadgeCounts',
			'setChatBadgeTotal',
			'setChatRecipientOnlineStatuses',
			'setChatlastMessageReceived',
			'setAlertMessage',
		]);
	}
	disconnect = () => {
		this.closeSocket();
	}
	connect = () => {
		const socketStatus = this.getSocketStatus();
		if (socketStatus === SOCKET_STATUS__OPEN ||
			socketStatus === SOCKET_STATUS__CONNECTING ||
			socketStatus === SOCKET_STATUS__RETRYING) {
				// Socket is already open
				return;
		}
		
		this.setupSocket();
	}
	handleAppStateChange = (appState) => {
		// The following happens when appState changes from APP_STATE_ACTIVE:
		// If appState === APP_STATE_INACTIVE, socket messages will still be processed as normal.
		// If appState === APP_STATE_BACKGROUND, socket messages will be queued and then processed 
		// when the app returns to APP_STATE_ACTIVE.

		if (AppGlobals.debugMode) {
			console.log('handleAppStateChange', appState);
		}
		const socket = this.getSocket();
		if (!socket) {
			return;
		}
		socket.send(JSON.stringify({
			type: CHAT_MSG_TYPE__APP_STATE_CHANGE,
			appState,
		}));

		if (appState === APP_STATE_ACTIVE) {
			// TODO: Test socket to see if it is still connected
			// Ping socket server
		}
	}
	sendAlert = (msg) => {
		this.emit('setAlertMessage', msg);
	}
	// hasConversation = (conversation_num) => {
	// 	return !!this.conversations[conversation_num];
	// }
	getConversations = () => {
		return this.conversations;
	}
	setConversations = (conversations) => {
		this.conversations = conversations;
	}
	// getConversation = (conversation_num) => {
	// 	if (!this.conversations[conversation_num]) {
	// 		return null;
	// 	}
	// 	return this.conversations[conversation_num];
	// }
	// setConversation = (conversation) => {
	// 	this.conversations[conversation.conversation_num] = conversation;
	// }
	getCurrentConversationNum = () => {
		return this.currentConversation && this.currentConversation.conversation_num;
	}
	getCurrentRecipientId = () => {
		return this.currentConversation && this.currentConversation.recipient_id;
	}
	setCurrentRecipient = (chatRecipient) => {
		let currentConversation = null;
		if (chatRecipient) {
			const conversation_num = chatRecipient.chat_recipients__conversation_num;
			currentConversation = this.conversations[conversation_num];
			this.currentConversation = currentConversation;
		} else {
			this.currentConversation = null;
		}
		this.emit('setChatCurrentConversation', currentConversation);
	}
	getCurrentScreen = () => {
		return this.reduxGetState().app.currentScreen;
	}
	getCurrentTab = () => {
		return this.reduxGetState().app.currentTab;
	}
	getUser = () => {
		return this.reduxGetState().app.user;
	}
	getChatToken = async () => {
		if (!this.chatToken) {
			await this.getChatTokenViaAjax();
		}
		return this.chatToken;
	}
	getChatTokenViaAjax = async () => {
		let newToken;
		const params = {
			baseURL: this.ChatMessages.api.baseURL,
			url: 'ChatMessages/getToken',
			method: 'POST',
			timeout: 5000,
			headers: getTokenHeaders(),
		};
		if (AppGlobals.debugMode) {
			console.log('getChatTokenViaAjax', params);
		}
		const result = await this.ChatMessages.axios(params).catch(error => {
			console.log('Error', 'Could not get chatToken', error);
		});
		
		if (!result || !result.data || !result.data.token) {
			console.log('Socket Error', 'Could not parse token', result);
			return;
		}

		newToken = result.data.token;

		if (AppGlobals.debugMode) {
			console.log('chatToken received', newToken);
		}
			
		
		this.setChatToken(newToken);
		return newToken;
	}
	setChatToken = (chatToken) => {
		this.chatToken = chatToken;
	}
	getSocket = () => {
		return this.socket;
	}
	setSocket = (socket) => {
		this.socket = socket;
	}
	getRetryAttempt = () => {
		return this.retryAttempt;
	}
	setRetryAttempt = (retryAttempt) => {
		this.retryAttempt = retryAttempt;
	}
	getSocketStatus = () => {
		return this.socketStatus;
	}
	setSocketStatus = (socketStatus) => {
		this.socketStatus = socketStatus;
		this.emit('setChatSocketStatus', socketStatus);
		this.emit('setChatIsSocketConnected', socketStatus === SOCKET_STATUS__OPEN);
	}
	getRecipientsOnlineStatuses = () => {
		return this.receipientsOnlineStatuses;
	}
	setRecipientsOnlineStatuses = (statuses) => {
		this.receipientsOnlineStatuses = _.clone(statuses);
		this.emit('setChatRecipientOnlineStatuses', statuses);
	}
	setRecipientOnlineStatus = (recipient_id, recipientStatus) => {
		const receipientsOnlineStatuses = _.clone(this.receipientsOnlineStatuses);
		receipientsOnlineStatuses[recipient_id] = recipientStatus;
		this.setRecipientsOnlineStatuses(receipientsOnlineStatuses);
	}
	getCurrentRecipientOnlineStatus = () => {
		if (!this.currentConversation || !this.currentConversation.recipient_id) {
			return CHAT_STATUS_OFFLINE;
		}
		const recipient_id = this.currentConversation.recipient_id;
		return this.receipientsOnlineStatuses[recipient_id];
	}
	isCurrentRecipientOnline = () => {
		return this.getCurrentRecipientOnlineStatus() === CHAT_STATUS_ONLINE;
	}
	clearBadgesForCurrentRecipient = () => {
		const conversation_num = this.getCurrentConversationNum();
		this.badgeCounts[conversation_num] = 0;
		this.setBadgeCountTotal();
	}
	getBadgeCounts = () => {
		return this.badgeCounts;
	}
	setBadgeCounts = (badgeCounts) => {
		this.badgeCounts = badgeCounts;
		this.setBadgeCountTotal();
	}
	setBadgeCount = (conversation_num, count) => {
		if (count === '+1') {
			if (!this.badgeCounts[conversation_num]) {
				this.badgeCounts[conversation_num] = 0;
			}
			this.badgeCounts[conversation_num]++;
		} else {
			this.badgeCounts[conversation_num] = count;
		}
		this.setBadgeCountTotal();
	}
	setBadgeCountTotal = () => {
		const badgeCounts = _.clone(this.badgeCounts); // So Redux recognizes changes
		let total = 0;
		_.each(badgeCounts, (value) => {
			if (_.isInteger(value)) {
				total += value;
			}
		});
		this.badgeCountTotal = total;
		this.emit('setChatBadgeTotal', total);
		this.emit('setChatBadgeCounts', badgeCounts);
	}
	setIsTyping = (bool) => {
		this.isTyping = bool;
	}
	setCurrentRecipientIsTyping = (bool) => {
		this.currentRecipientIsTyping = bool;
		this.emit('setChatRecipientIsTyping', bool);
	}
	getCurrentRecipientIsTyping = () => {
		return this.currentRecipientIsTyping;
	}
	setupSocket = async () => {
		if (AppGlobals.debugMode) {
			console.log('setupSocket');
		}

		const chatToken = await this.getChatToken();
		if (!chatToken) {
			if (AppGlobals.debugMode) {
				console.log('no chatToken, quit setupSocket');
			}
			return;
		}

		const user = this.getUser();
		if (!user) {
			if (AppGlobals.debugMode) {
				console.log('no user, quit setupSocket');
			}
			return;
		}

		const
			uri = AppGlobals.socketURL,
			queryString = '?user_id=' + user.id +
						'&domain=' + (AppGlobals.domain?.domains__subdomain || AppGlobals.domain) +
						'&token=' + chatToken,
			uq = uri + queryString;

		if (AppGlobals.debugMode) {
			console.log('Open socket at', uq);
		}
		socket = new WebSocket(uq);

		socket.addEventListener('open', (e) => {
			if (AppGlobals.debugMode) {
				console.log('socket open');
			}
			this.setSocketStatus(SOCKET_STATUS__OPEN);
			this.setChatToken(null);
			this.setRetryAttempt(0);
			this.sendCommand(CHAT_COMMAND__GET_RECIPIENTS_ONLINE_STATUSES);
			this.keepAlive();
		});

		socket.addEventListener('message', (e) => {
			if (AppGlobals.debugMode) {
				console.log('socket message', e);
			}
			this.onMessageReceived(e);
		});

		socket.addEventListener('error', (e) => {
			if (AppGlobals.debugMode) {
				console.log('socket error', e.message);
			}
			if (e.message && e.message.match(/refused/i)) {
				this.setSocketStatus(SOCKET_STATUS__REFUSED);
			}
		});

		socket.addEventListener('close', async (e) => {
			const socketStatus = this.getSocketStatus();

			if (AppGlobals.debugMode) {
				console.log('socket close', e);
			}

			if (socketStatus === SOCKET_STATUS__CLOSING) {
				// Close was expected.
				this.setSocketStatus(SOCKET_STATUS__CLOSED);
				return;
			}

			// Close was unexpected. Try to reconnect
			if (AppGlobals.debugMode) {
				console.log('trying to reconnect');
			}

			await this.getChatToken();

			let delay;
			const retryAttempt = this.getRetryAttempt();
			if (socketStatus === SOCKET_STATUS__REFUSED) {
				this.setRetryAttempt(1);
				this.sendAlert('Chat conection refused. Will try again in 2 minutes.');
				delay = 120000; // 2 minutes
				this.sendErrorMessageViaAjax('Socket conection refused. ' + uri + queryString);
			} else if (retryAttempt === 4) {
				this.setRetryAttempt(1);
				this.setSocketStatus(SOCKET_STATUS__FAILED);
				this.sendAlert('Chat conection failed. Will try again in 2 minutes.');
				delay = 120000; // 2 minutes
				this.sendErrorMessageViaAjax('Socket conection failed. ' + uri + queryString);
			} else {
				this.setRetryAttempt(retryAttempt +1);
				this.setSocketStatus(SOCKET_STATUS__RETRYING);
				delay = _.random(3.1, 7.0) * 1000; // Random interval between 3-7 seconds (we don't want everyone reconnecting at the same time!)
			}

			setTimeout(() => {
				this.setupSocket();
			}, delay);
		});

		this.setSocket(socket);
		
		if (AppGlobals.debugMode) {
			console.log('socket created');
		}
	}
	keepAlive = () => {
		setTimeout(() => {
			this.pingServer();
		}, pingTimeout);
	}
	pingServer = () => {
		if (this.getSocketStatus() === SOCKET_STATUS__OPEN) {
			this.getSocket().send(JSON.stringify({
				type: CHAT_MSG_TYPE__PING,
			}));
			this.keepAlive();
		}
	}
	closeSocket = () => {
		if (AppGlobals.debugMode) {
			console.log('closeSocket');
		}
		const socket = this.getSocket();
		if (socket) {
			this.setSocketStatus(SOCKET_STATUS__CLOSING);
			socket.close();
		}
	}
	sendCommand = (cmd) => {
		if (AppGlobals.debugMode) {
			console.log('sendCommand', cmd);
		}
		this.getSocket().send(JSON.stringify({
			type: CHAT_MSG_TYPE__COMMAND,
			cmd,
		}));
	}
	sendIsTyping = () => {
		if (AppGlobals.debugMode) {
			console.log('sendIsTyping');
		}
		const currentConversationNum = this.getCurrentConversationNum();
		this.getSocket().send(JSON.stringify({
			type: CHAT_MSG_TYPE__IS_TYPING,
			conversation_num: currentConversationNum,
		}));
	}
	sendMessage = (data) => { // External API
		data = data[0];
		const msg = data.text,
			conversation_num = this.getCurrentConversationNum();

		if (AppGlobals.debugMode) {
			console.log('sendMessage', msg);
		}

		this.getSocket().send(JSON.stringify({
			type: CHAT_MSG_TYPE__CHAT_MSG,
			conversation_num,
			msg,
		}));
		this.addMessageToLocalRepository({
			id: null,
			user_id: this.getUser()?.id,
			conversation_num,
			datetime: new Date(),
			msg,
		});
		if (userIsTypingTimeout) {
			clearTimeout(userIsTypingTimeout);
		}
	}
	addMessageToLocalRepository = async (data) => {
		if (AppGlobals.debugMode) {
			console.log('addMessageToLocalRepository', data);
		}
		// OPTIMIZATION NOTICE:
		// We could've simply done this after every sent/received message:
		// 		this.ChatMessages.reload();
		// That would've fetched the latest data and re-rendered the Chat component.
		// However, it would've *also* caused every chat client to *dramatically* increase its
		// bandwidth usage, and forced the backend to run many more DB queries.
		// To optimize this, we're going to directly inject the new message to the Repository.
		this.ChatMessages.pauseEvents();
		await this.ChatMessages.add(data);
		this.ChatMessages.resumeEvents();

		// Force re-render
		this.ChatMessages.entities = _.clone(this.ChatMessages.entities);
		this.ChatMessages.emit('changeData', this.ChatMessages.entities);
	}
	sendErrorMessageViaAjax = async (msg) => {
		if (AppGlobals.debugMode) {
			console.log('sendErrorMessageViaAjax');
		}
		const url = '/ChatMessages/sendError',
			result = await this.ChatMessages._send('POST', url, { msg, headers: getTokenHeaders(), })
							.catch(error => {
								if (AppGlobals.debugMode) {
									console.log(url + ' error', error);
									console.log('response:', error.response);
								}
							}),
			parsed = JSON.parse(result.data),
			{
				status,
			} = parsed;

		if (AppGlobals.debugMode) {
			console.log('sendErrorMessageViaAjax response', status);
		}
	}
	onMessageReceived = (e) => {
		const parsed = JSON.parse(e.data),
			{
				cmd,
				type,
				user_id, // person sending the message
				conversation_num,
				recipient_id,
				full_name,
				msg,
				status,
				statuses, // format: { recipient_id: status, }
			} = parsed;
		
		if (AppGlobals.debugMode) {
			console.log('onMessageReceived', parsed);
		}
		
		switch(type) {
			case CHAT_MSG_TYPE__CHAT_MSG:
				const
					currentScreen = this.getCurrentScreen(),
					currentTab = this.getCurrentTab();
				if (currentTab !== 'Chat' || currentScreen !== 'ChatMessages') {
					this.setBadgeCount(conversation_num, '+1');
				}
				if (conversation_num == this.getCurrentConversationNum()) {
					this.setCurrentRecipientIsTyping(false);
					this.addMessageToLocalRepository({
						id: null,
						user_id, // person sending the message
						conversation_num,
						datetime: new Date(),
						msg,
						user: { // Add this so ChatMessages screen can display user properly
							id: user_id,
							full_name,
						},
					});
				}
				this.emit('setChatlastMessageReceived');
				break;
			case CHAT_MSG_TYPE__ERROR:
				console.log('Socket Error', msg);
				this.sendAlert(msg);
				break;
			case CHAT_MSG_TYPE__IS_TYPING:
				if (user_id != this.getCurrentRecipientId()) {
					return;
				}

				const currentRecipientIsTyping = this.getCurrentRecipientIsTyping();
				if (!currentRecipientIsTyping) {
					this.setCurrentRecipientIsTyping(true);
				}
				if (currentRecipientIsTypingTimeout) {
					clearTimeout(currentRecipientIsTypingTimeout);
				}
				currentRecipientIsTypingTimeout = setTimeout(() => {
					this.setCurrentRecipientIsTyping(false);
				}, 5000);
				break;
			case CHAT_MSG_TYPE__RECIPIENT_STATUS_CHANGE:
				this.setRecipientOnlineStatus(recipient_id, status);
				break;
			case CHAT_MSG_TYPE__OFFLINE_WAIT:
				this.sendAlert(msg);
				break;
			case CHAT_MSG_TYPE__COMMAND_RESPONSE:
				// parse the command response, based on which command originated it
				switch(cmd) {
					case CHAT_COMMAND__GET_RECIPIENTS_ONLINE_STATUSES:
						this.setRecipientsOnlineStatuses(statuses);
						break;
				}
				break;
		}
	}
	onInputTextChanged = (text) => { // External API
		if (text === '') {
			return;
		}
		
		// Fire event, throttled
		if (!this.isTyping) {
			this.setIsTyping(true);
			this.sendIsTyping();
		}
		if (userIsTypingTimeout) {
			clearTimeout(userIsTypingTimeout);
		}
		userIsTypingTimeout = setTimeout(() => {
			this.setIsTyping(false);
		}, 1000);
	}
}
